import React, { useEffect, useState } from 'react'
import useAxiosFetchData from '../../../hooks/useAxiosFetchData'
// import API_Routes from '../../../../constants/api-routes'
import { useSelector } from 'react-redux'
import AutoCompleteMultiSelectDropdown from '../AutoCompleteMultiSelectDropdown';
import PropTypes from 'prop-types';


function TagOldFeedback({ url, feedbackBidderId, oldFeedbackValueChange, taggedFeedbackList, feedbackId, id, newFeedback=false }) {


    PropTypes.checkPropTypes({
        feedbackBidderId: PropTypes.string.isRequired || PropTypes.number.isRequired,
        oldFeedbackValueChange: PropTypes.func.isRequired,
    }, { feedbackBidderId, oldFeedbackValueChange }, 'feedbackBidderId and oldFeedbackValueChange are required in TagOldFeedback');


    const { csrfToken } = useSelector(state => state.csrf);
    const [headers, setHeaders] = useState({
        'Accept': '*/*',
        'X-Csrf-Token': csrfToken,
        'Content-Type': 'application/json',
    })
    const [serviceId, setServiceId] = useState(useSelector(state => state.role.userCurrRole.department.id));
    const {userId:bidderId} = useSelector(state=>state.role);
    const [oldFeedbackPayload, setOldFeedbackPayload] = useState({ bidderId: (feedbackBidderId!==null&&feedbackBidderId!==undefined)?feedbackBidderId:bidderId, serviceId: serviceId });
    const [oldFeedbackList, setOldFeedbackList] = useState([]);

    // debugger;
    const { fetchData: fetchOldFeedbacks } = useAxiosFetchData({
        url: url  /*API_Routes.getCustomerOldFeedbackList*/, //<------ REVIEW THIS
        method: 'post',
        body: oldFeedbackPayload,
        headers: headers,
        onLoad: true
    })




    useEffect(() => {
        // console.log("TagOldFeedback useEffect", feedbackBidderId, id,feedbackId);
        fetchOldFeedbacks().then((response) => {
            if (response) {
                setOldFeedbackList(response);
            }
        })
    }, [feedbackBidderId, fetchOldFeedbacks, serviceId])
    return (
        <AutoCompleteMultiSelectDropdown
            values={oldFeedbackList}
            taggedFeedbackList={taggedFeedbackList}
            onValueChange={oldFeedbackValueChange}
            feedbackId={feedbackId}
            id={id}
            bidderId={feedbackBidderId}
            newFeedback={newFeedback}
        >

        </AutoCompleteMultiSelectDropdown>
    )
}


export default TagOldFeedback